import { ReactNode } from 'react';

interface RowProps {
  children: ReactNode;
}

const Row = ({ children }: RowProps): JSX.Element => <div className="row">{children}</div>;

export default Row;
